import { render, staticRenderFns } from "./PageTitleContainer.vue?vue&type=template&id=fc66e932&"
import script from "./PageTitleContainer.vue?vue&type=script&lang=js&"
export * from "./PageTitleContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports